import { Component } from '@angular/core';
import { Color } from '@lsq-frontend/common-ui';
import { Icons } from '@lsq-frontend/common-ui';
import { ModalService } from '@lsq-frontend/common-ui';

@Component({
    selector: 'request-pay-later-confirmation-modal',
    template: `
        <div class="request-payment-confirmation-success-wrapper">
            <div class="success-message">
                <lsq-icon
                    [type]="icons.CheckmarkCircleLarge"
                    [color]="color.Green"
                    [height]="80"
                    [width]="80"
                >
                </lsq-icon>
                <div class="success-message-received-text">
                    <span i18n>Total Invoice Amount </span>
                    <span>{{ modalService.modal?.data?.totalInvoiceAmount | lsqCurrency }}</span>
                </div>
                <div class="success-message-received-text">
                    <span i18n>Previously Early Paid Amount </span>
                    <span>{{ modalService.modal?.data?.earlyPaymentAmount | lsqCurrency }}</span>
                </div>
                <div class="success-message-received-text">
                    <span i18n>Total Amount To Be Paid </span>
                    <span>{{ modalService.modal?.data?.totalPaymentAmount | lsqCurrency }}</span>
                </div>
                <div class="success-message-received-text">
                    <span i18n>Your FlexTerm request has been processed!</span>
                </div>
                <div class="success-message-text">
                    <span i18n>
                        You can view all processed FlexTerm Invoices on the "Invoices" page.
                    </span>
                </div>
            </div>
        </div>
    `,
    styleUrls: ['./request-pay-later-confirmation-modal.component.scss']
})
export class RequestPayLaterConfirmationModalComponent {
    public color = Color;
    public icons = Icons;

    constructor(public modalService: ModalService) {}
}
